"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const projects = [{
  id: "proj-1",
  title: "Tailings and Water Impoundment",
  category: "Geotechnical EOR",
  image: "https://pretty-alien.10web.cloud/wp-content/uploads/2026/04/project_industrial_park.webp?v=pyotyt6e54",
  link: "/ServicesPage"
}, {
  id: "proj-2",
  title: "Phosphogypsum Stack\xA0",
  category: "Construction Support",
  image: "https://pretty-alien.10web.cloud/wp-content/uploads/2026/04/tailings_dam_oversight.webp?v=trco5fm8qoe",
  link: "/ServicesPage"
}, {
  id: "proj-3",
  title: "Tailings Monitoring Support",
  category: "OPERATIONAL MANAGEMENT",
  image: "https://pretty-alien.10web.cloud/wp-content/uploads/2026/04/tailings_operations_support.webp?v=7sog1ipizcu",
  link: "/ServicesPage"
}, {
  id: "proj-4",
  title: "GISTM Compliance Audit",
  category: "Risk & Oversight",
  image: "https://pretty-alien.10web.cloud/wp-content/uploads/2026/04/compliance_audit_review.png?v=cmxityomhp8",
  link: "/ServicesPage"
}];
export default function IndustryPortfolio() {
  return <section data-section-id="116551" id="international-project-footprint" className="dark bg-background py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          {}
          <div className="mb-12 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
            <div className="max-w-2xl">
              <span className="mb-3 block font-mono text-xs font-bold uppercase tracking-widest text-primary">
                Global Expertise
              </span>
              <h2 className="font-sans text-4xl font-extrabold tracking-tighter text-foreground md:text-6xl">
                Global Project Experience
              </h2>
            </div>
            
            {}
            <div className="flex shrink-0 gap-4">
              <CarouselPrevious variant="outline" className="static size-12 translate-x-0 translate-y-0 rounded-sm border-primary bg-transparent text-primary hover:bg-primary hover:text-primary-foreground transition-colors duration-300" />
              <CarouselNext variant="outline" className="static size-12 translate-x-0 translate-y-0 rounded-sm border-primary bg-transparent text-primary hover:bg-primary hover:text-primary-foreground transition-colors duration-300" />
            </div>
          </div>

          {}
          <CarouselContent className="-ml-4 md:-ml-8">
            {projects.map((project, i) => <CarouselItem key={project.id} data-index={i} className="pl-4 md:basis-1/2 md:pl-8 lg:basis-1/3">
                <Link to={project.link} className="group block h-full">
                  <div className="relative aspect-[4/3] w-full overflow-hidden bg-muted">
                    <img src={project.image} alt={project.title} className="h-full w-full object-cover grayscale transition-all duration-700 ease-in-out group-hover:scale-105 group-hover:grayscale-0" />
                    
                    {}
                    <div className="absolute bottom-0 left-0 max-w-[90%] border-t border-r border-border bg-background/90 p-6 backdrop-blur-md transition-all duration-300 group-hover:bg-primary group-hover:border-primary">
                      <span className="mb-1 block font-mono text-[10px] font-bold uppercase tracking-widest text-secondary group-hover:text-primary-foreground/80">
                        {project.category}
                      </span>
                      <h3 className="font-sans text-lg font-extrabold leading-tight text-foreground group-hover:text-primary-foreground">
                        {project.title}
                      </h3>
                      <div className="mt-4 h-0.5 w-0 bg-primary-foreground transition-all duration-500 group-hover:w-full" />
                    </div>
                  </div>
                </Link>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>
      </div>
    </section>;
}